import { render } from "./FooterComponent.vue?vue&type=template&id=4f99a9ba"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__